export class SearchSorting {
  column: string;
  isDescending: boolean;
}
